import {
  Button,
  Chip,
  DrawerFooter,
  Link,
} from '@one-thd/sui-atomic-components';
import React from 'react';
import { UserFilterSettings } from '../../../models/order-filter';

interface IOrderFilterFooterProps {
  filterSettings: UserFilterSettings;
  pHRequestResultsFilter?: string;
  username: string;
  poJobNameFilter: string[];
  paymentFilter: string[];
  totalAmountFilter: string;
  setFilterSettings: React.Dispatch<React.SetStateAction<UserFilterSettings>>;
  setPOJobNameFilter: React.Dispatch<React.SetStateAction<string[]>>;
  setPaymentFilter: React.Dispatch<React.SetStateAction<string[]>>;
  resetTotalAmountFilter: () => void;
  onViewResults: () => void;
  isFilterChanged: boolean;
  setFilterChanged: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OrderFilterFooter = ({
  filterSettings,
  pHRequestResultsFilter,
  username,
  poJobNameFilter,
  paymentFilter,
  totalAmountFilter,
  setFilterSettings,
  setPOJobNameFilter,
  setPaymentFilter,
  resetTotalAmountFilter,
  onViewResults,
  isFilterChanged,
  setFilterChanged,
}: IOrderFilterFooterProps) => {
  const shouldShowUserChip = filterSettings.userView !== 'allOrders';
  const activeChipCount = [
    shouldShowUserChip ? 1 : 0,
    poJobNameFilter.length,
    paymentFilter.length,
    totalAmountFilter ? 1 : 0,
  ].reduce((sum, n) => sum + n, 0);

  const resetUserViewToAllOrders = () => {
    setFilterSettings((prevState: UserFilterSettings) => ({
      ...prevState,
      userView: 'allOrders',
    }));
  };

  return (
    <DrawerFooter>
      <div className="sui-grid sui-grid-cols-1 sui-gap-4 sui-w-full sui-mb-2">
        <ul
          className="sui-flex sui-gap-4 sui-max-w-[640px] sui-overflow-x-auto sui-list-none sui-p-0 sui-m-0"
          aria-label="Click any of the filters to remove it"
        >
          {activeChipCount >= 2 && (
            <li>
              <Link
                component="button"
                className="sui-whitespace-nowrap sui-shrink-0"
                onClick={() => {
                  resetUserViewToAllOrders();
                  setPOJobNameFilter([]);
                  setPaymentFilter([]);
                  resetTotalAmountFilter();
                  setFilterChanged(true);
                }}
              >
                Clear All
              </Link>
            </li>
          )}
          {shouldShowUserChip && (
            <li>
              <Chip
                title="User"
                label={
                  filterSettings.userView === 'allOrders'
                    ? 'Everyone'
                    : username
                }
                onClick={resetUserViewToAllOrders}
              />
            </li>
          )}
          {poJobNameFilter.map((value) => (
            <li key={value}>
              <Chip
                title="PO/Job"
                label={value}
                onClick={() => {
                  setPOJobNameFilter((prev) =>
                    prev.filter((prevValue) => prevValue !== value),
                  );
                  setFilterChanged(true);
                }}
              />
            </li>
          ))}
          {paymentFilter.map((value) => (
            <li key={value}>
              <Chip
                title="Payment"
                label={value}
                onClick={() => {
                  setPaymentFilter((prev) =>
                    prev.filter((prevValue) => prevValue !== value),
                  );
                  setFilterChanged(true);
                }}
              />
            </li>
          ))}
          {totalAmountFilter && (
            <li>
              <Chip
                title="Total Amount"
                label={totalAmountFilter}
                onClick={() => {
                  resetTotalAmountFilter();
                  setFilterChanged(true);
                }}
              />
            </li>
          )}
        </ul>
      </div>
      <Button
        variant="primary"
        fullWidth
        disabled={
          filterSettings.userView === pHRequestResultsFilter && !isFilterChanged
        }
        onClick={onViewResults}
      >
        View Results
      </Button>
    </DrawerFooter>
  );
};
